import React, { useState } from 'react'
import Image from 'next/image'
import PropTypes from 'prop-types'

import styles from './TestimonialSlider.module.scss'

const TestimonialSlider = ({
  slides = [],
  author = '',
  text = '',
  avatar = '',
}) => {
  const [currentIndex, setCurrentIndex] = useState(0)

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? slides.length - 1 : prevIndex - 1))
  }

  const goToNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length)
  }

  return (
    <div className={styles.sliderContainer}>
      <div className={styles.testimonialItem}>
        <div className={styles.imagesContainer}>
          <button className={styles.leftArrow} onClick={goToPrevious}>
            &#10094;
          </button>
          <Image
            alt={author}
            src={slides[currentIndex].image}
            style={{ height: 'auto' }}
          />
          <button className={styles.rightArrow} onClick={goToNext}>
            &#10095;
          </button>
        </div>
        <p className={styles.testimonialText}>“{text}“</p>
        <div className={styles.author}>
          <Image
            alt={author}
            src={avatar}
          />
          <h4>{author}</h4>
        </div>
      </div>
    </div>
  )
}

TestimonialSlider.propTypes = {
  author: PropTypes.string,
  text: PropTypes.string,
  avatar: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  slides: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    }),
  ),
}

export default TestimonialSlider
